<header class="header-container" [class.use-page-background]="usePageBackground()">
  <!-- Bouton retour ou spacer -->
  @if (showBackButton()) {
  <button type="button" class="back-btn" (click)="goBack()" aria-label="Retour">
    <span>‹</span>
  </button>
  } @else {
  <div class="header-spacer"></div>
  }

  <!-- Titre ou logo centré -->
  @if (title()) {
  <h1 class="page-title">{{ title() }}</h1>
  } @else {
  <h1
    (click)="navigateToWelcome()"
    class="clickable"
    (keydown.enter)="navigateToWelcome()"
    (keydown.space)="navigateToWelcome()"
    tabindex="0"
  >
    SAL<span class="yellow">OO</span>NS
  </h1>
  }

  <!-- Action saloon à la demande -->
  @if (showMenu()) {
  <button
    type="button"
    class="plus-btn"
    (click)="goToSaloonRequest()"
    aria-label="Saloon à la demande"
  >
    <span>+</span>
  </button>
  } @else {
  <div class="header-spacer"></div>
  }
</header>
